<header
  class="filters-panel-head"
  [class.filters-panel-head--desktop-only]="desktopOnly()">
  <span class="filters-panel-head__icon" aria-hidden="true">
    <i class="iconsax" [attr.icon-name]="icon()"></i>
  </span>
  <h2 class="filters-panel-head__title">
    {{ titleKey() | translate }}
  </h2>
</header>
